export interface CustomerFoodFeedback {
  id: number;
  customer_id: number;
  order_id: number;
  bundle_id: number | null;
  product_id: number | null;
  pairing_id: number | null;
  food_feedback_id: number;
  preference?: CustomerFoodFeedbackPreference;
  tags: Array<{
    tag_id: number;
    // Tag preferences are not always a like/dislike. For example,
    // if the specific food feedback is for nutrition, and the
    // preference for nutrition is -1 (disliking), any tags
    // associated with it are still a 1 indicating that the user
    // cares about it rather than a dislike/like.
    preference?: number;
  }> | null;
}

export enum CustomerFoodFeedbackPreference {
  Dislike = -1,
  Like = 1,
}
